import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions";

const mapStateToProps = (state) => {
    return {
        portfolioAllocation: state.jarvisPrime.primeDashboard.portfolioAllocation,
        portfolioAllocationCount: state.jarvisPrime.primeDashboard.portfolioAllocationCount,
        portfolioAllocationLoading: state.jarvisPrime.primeDashboard.loading.portfolioAllocation,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getPortfolioAllocationsListAction: jarvisPrimeDashboardActions.getPortfolioAllocations,
        },
        dispatch
    );

const PortfolioAllocationStore = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
export default PortfolioAllocationStore;
